import React from 'react';
import HeaderLogo from './HeaderLogo';

const PageHeader: React.FC = () => {
  return (
    <header className="w-full h-[82px] bg-white dark:bg-gray-800 border-b border-[#F0F0F0] flex items-center px-8">
      <HeaderLogo />
    </header>
  );
};

export default PageHeader;
